import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  BASE_URL,
  PRODUCT_IMAGES_BASE_URL,
  BASE_URL_FOR_ELASTIC_SEARCH,
  CONFIG_CAT_LIST
} from '../../../Constants/Config';

import { waitForElasticConnection } from '../../../hooks/checkElasticConnection.js';

const initialState = {
  loading: false,
  configCategoryList: [],
  error: '',
  lastFetched: null, // Track when data was last fetched
};

export const fetchConfigCategoryList = createAsyncThunk(
  'configCategoryList/fetchConfigCategoryList',
  async (data, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const { configCategoryList, lastFetched } = state.configCategoryList;
      
      // Check if data is already cached and fresh (less than 5 minutes old)
      const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds
      const now = Date.now();
      
      if (configCategoryList.length > 0 && lastFetched && (now - lastFetched) < CACHE_DURATION) {
        return configCategoryList; // Return cached data
      }


      const isElasticConnected = await waitForElasticConnection(getState);
      const baseUrl = isElasticConnected
        ? BASE_URL_FOR_ELASTIC_SEARCH
        : BASE_URL;
      
      const response = await axios.post(
        BASE_URL +   CONFIG_CAT_LIST,
        data,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );

      if (response?.data?.status) {
        const catData = response.data.cat_data;
        return catData;
      } else {
        return rejectWithValue('No category data received');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch category list');
    }
  },
);

const configCategoryListSlice = createSlice({
  name: 'configCategoryList',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchConfigCategoryList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchConfigCategoryList.fulfilled, (state, action) => {
      state.loading = false;
      state.configCategoryList = action.payload || [];
      state.error = '';
      state.lastFetched = Date.now(); // Set timestamp when data was fetched
    });
    builder.addCase(fetchConfigCategoryList.rejected, (state, action) => {
      state.loading = false;
      // Don't clear existing data on error, keep what we have
      state.error = action.payload || action.error?.message || 'Failed to fetch categories';
    });
  },
});

export default configCategoryListSlice.reducer;
